"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var TabsContext_1 = require("./TabsContext");
var Tabs = function (_a) {
    var uid = _a.uid, _b = _a.vertical, vertical = _b === void 0 ? false : _b, currentIndex = _a.currentIndex, onChanging = _a.onChanging, onChange = _a.onChange, rest = __rest(_a, ["uid", "vertical", "currentIndex", "onChanging", "onChange"]);
    return (react_1["default"].createElement(TabsContext_1.TabsProvider, { uid: uid, vertical: vertical, currentIndex: currentIndex, onChanging: onChanging, onChange: onChange },
        react_1["default"].createElement(ElementTag_1["default"], __assign({}, rest))));
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map